import {ContributionType} from '@core-app/types/contribution.interface';
import {PillarType} from '@core-app/types/pillar.type';

export const ContributionDataShape: Record<
    PillarType,
    Record<string, ContributionType>
> = {
    health: {
        medical: {
            title: 'MEDICAL_PLAN_TITLE',
            ee: 'MEDICAL_EE',
            er: 'MEDICAL_ER',
            link: {
                href: 'https://mycigna.com',
                text: 'Cigna',
            },
        },
        dental: {
            title: 'DENTAL_PLAN_TITLE',
            ee: 'DENTAL_EE',
            er: 'DENTAL_ER',
            link: {
                href: 'https://mybenefits.metlife.com',
                text: 'MetLife',
            },
        },
        vision: {
            title: 'VISION_PLAN_TITLE',
            ee: 'VISION_EE',
            er: 'VISION_ER',
            link: {
                href: 'https://vsp.com',
                text: 'VSP',
            },
        },
        eap: {
            title: 'Employee Assistance Program - Concern',
            er: 'EAP_ER',
            link: {
                href: 'https://employee.concernhealth.com',
                text: 'Concern',
            },
        },
    },
    wealth: {
        '401k': {
            title: '401(k) - Principal Financial',
            ee: '401K_EE',
            er: '401K_ER',
            tooltip:
                'Annual contributions are based on your current contribution percentage and your estimated annualized compensation.',
            link: {
                href: 'https://principal.com',
                text: 'Principal',
            },
        },
        profit_sharing: {
            title: 'Profit Sharing - Principal Financial',
            er: 'PROFIT_SHARING_ER',
            tooltip:
                "Profit Sharing is contingent upon meeting 401(k) Plan eligibility requirements and Company's profitability.",
            link: {
                href: 'https://principal.com',
                text: 'Principal',
            },
        },
        hsa: {
            title: 'HSA_FUND_LABEL',
            suffix: 'HSA Cigna',
            ee: 'HSA_FUND_EE',
            er: 'HSA_FUND_ER',
            link: {
                href: 'https://mycigna.com',
                text: 'Cigna',
            },
        },
        fsa_healthcare: {
            title: 'Flexible Spending Account - Healthcare',
            ee: 'FSA_HEALTHCARE_EE',
            link: {
                href: 'https://naviabenefits.com',
                text: 'Navia',
            },
        },
        fsa_dependent_care: {
            title: 'Flexible Spending Acccount - Dependent Care',
            ee: 'FSA_DEPENDENT_CARE_EE',
            link: {
                href: 'https://naviabenefits.com',
                text: 'Navia',
            },
        },
    },
    protection: {
        basic_life: {
            title: 'Basic Term Life - Reliance Standard',
            er: 'BASIC_TERM_LIFE_ER',
            link: {
                href: 'https://reliancestandard.com',
                text: 'Reliance Standard',
            },
        },
        basic_add: {
            title: 'Basic AD&D - Reliance Standard',
            er: 'BASIC_ADD_ER',
            link: {
                href: 'https://reliancestandard.com',
                text: 'Reliance Standard',
            },
        },
        std: {
            title: 'Short Term Disability - Matrix',
            er: 'STD_ER',
            link: {
                href: 'https://c2mb.ajg.com/solv/2025-employee-benefits/reliance-life-and-disability/',
                text: 'Matrix Absence',
            },
        },
        ltd: {
            title: 'Long Term Disability - Reliance Standard',
            er: 'LTD_ER',
            link: {
                href: 'https://c2mb.ajg.com/solv/2025-employee-benefits/reliance-life-and-disability/',
                text: 'Matrix Absence',
            },
        },
        vol_term_life_ee: {
            title: 'Voluntary Term Life - Reliance Standard',
            ee: 'VOL_TERM_LIFE_EE',
            link: {
                href: 'https://reliancestandard.com',
                text: 'Reliance Standard',
            },
        },
        vol_term_life_partner: {
            title: 'Voluntary Spouse Life - Reliance Standard',
            ee: 'VOL_TERM_LIFE_PARTNER',
            link: {
                href: 'https://reliancestandard.com',
                text: 'Reliance Standard',
            },
        },
        vol_term_life_child: {
            title: 'Voluntary Dependents Life - Reliance Standard',
            ee: 'VOL_TERM_LIFE_CHILD',
            link: {
                href: 'https://reliancestandard.com',
                text: 'Reliance Standard',
            },
        },
        ltc: {
            title: 'Long Term Care - Chubb',
            ee: 'LTC',
            link: {
                href: 'https://www.chubb.com/content/chubb-sites/chubb-com/na/cica-cwb/solv-energy.html',
                text: 'Chubb',
            },
        },
        legal_services: {
            title: 'Legal Services - MetLife Law',
            ee: 'LEGAL_SERVICES_EE',
            link: {
                href: 'https://legalplans.com',
                text: 'MetLife',
            },
        },
        critical_illness_ee: {
            title: 'Critical Illness - Voya',
            ee: 'CRITICAL_ILLNESS_EE',
            link: {
                href: 'https://presents.voya.com/EBRC/SOLVEnergy',
                text: 'Voya',
            },
        },
        critical_illness_partner: {
            title: 'Critical Illness Spouse - Voya',
            ee: 'CRITICAL_ILLNESS_PARTNER',
        },
        critical_illness_child: {
            title: 'Critical Illness Dependents - Voya',
            ee: 'CRITICAL_ILLNESS_CHILD',
            link: {
                href: 'https://presents.voya.com/EBRC/SOLVEnergy',
                text: 'Voya',
            },
        },
        hospital_indemnity: {
            title: 'HOSPITAL_IND_INS_LABEL',
            suffix: 'Voya',
            ee: 'HOSPITAL_IND_INS_EE',
            link: {
                href: 'https://presents.voya.com/EBRC/SOLVEnergy',
                text: 'Voya',
            },
        },
        accidental_injury: {
            title: 'ACCIDENTAL_INJURY_INS_LABEL',
            suffix: 'Voya',
            ee: 'ACCIDENTAL_INJURY_INS_EE',
            link: {
                href: 'https://presents.voya.com/EBRC/SOLVEnergy',
                text: 'Voya',
            },
        },
        business_accident: {
            title: 'Business Travel Accident Insurance - Zurich',
            ee: 'BUSINESS_TRAVEL_ACCIDENT',
            link: {
                href: 'https://zurichtravelassist.com',
                text: 'Zurich',
            },
        },
        id_theft: {
            // NOTE: This label will be transformed customly
            // in the `TrsService.getPlanTitle` method
            title: 'ID_THEFT_PROTECTION_LABEL',
            ee: 'ID_THEFT_PROTECTION_EE',
            link: {
                href: 'https://www.myaip.com',
                text: 'Allstate',
            },
        },
        pet_insurance: {
            title: 'Pet Insurance - Nationwide',
            ee: 'PET_INSURANCE',
            link: {
                href: 'https://benefits.petinsurance.com/solvenergy',
                text: 'Nationwide',
            },
        },
    },
    time: {
        vacation: {
            title: 'Vacation Pay',
            er: 'VACATION_PAY',
        },
        charitable: {
            title: 'Charitable/Volunteering',
            er: 'CHARITABLE_VOLUNTEERING_VALUE',
        },
    },
};
